"use client"

export const isTelegramInAppBrowser = (): boolean => {
  if (typeof window === "undefined") return false
  const w = window as any
  return (
    !!w.TelegramWebviewProxy ||
    !!w.TelegramWebviewProxyProto ||
    !!w.TelegramWebview ||
    /Telegram/i.test(navigator.userAgent)
  )
}
